import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const LaboratoryLogo = ({ id, name, size = 32 }) => {
    const [error, setError] = useState(false);
    const [preview, setPreview] = useState(null);
    const imgRef = useRef(null);

    const src = `${process.env.PUBLIC_URL}/images/laboratories/${id}.png`;

    const showPreview = () => {
        if (!imgRef.current) return;
        const rect = imgRef.current.getBoundingClientRect();
        setPreview({
            top: rect.top + rect.height / 2,
            left: rect.right + 10,
        });
    };

    const hidePreview = () => setPreview(null);

    if (error) {
        const initials = (name || '?').trim().charAt(0).toUpperCase();
        return (
            <div style={{
                width: size, height: size, borderRadius: '50%',
                backgroundColor: '#9ca3af',
                color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 'bold', fontSize: Math.max(9, Math.round(size * 0.4)), flexShrink: 0,
            }}>
                {initials}
            </div>
        );
    }

    return (
        <>
            <img
                ref={imgRef}
                src={src}
                alt={name}
                onError={() => setError(true)}
                onMouseEnter={showPreview}
                onMouseLeave={hidePreview}
                style={{
                    width: size, height: size, borderRadius: '50%',
                    objectFit: 'contain', border: '1px solid #e5e7eb', background: '#fff', flexShrink: 0,
                    cursor: 'pointer',
                }}
            />
            {preview && createPortal(
                <div
                    style={{
                        position: 'fixed',
                        top: preview.top,
                        left: preview.left,
                        transform: 'translateY(-50%)',
                        background: '#fff',
                        border: '1px solid #e5e7eb',
                        borderRadius: 12,
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                        padding: 10,
                        zIndex: 1100,
                        pointerEvents: 'none',
                    }}
                >
                    <img
                        src={src}
                        alt={name}
                        style={{ display: 'block', maxWidth: 200, maxHeight: 200, objectFit: 'contain' }}
                    />
                </div>,
                document.body
            )}
        </>
    );
};

export default LaboratoryLogo;
